export default "__VITE_ASSET__DM1vZ8dq__"